import {LonerPinTheWinCornerMulti} from "./LonerPinTheWinCornerMulti";
import {gsap} from "gsap";
import {Loner} from "../../../Loner";

export class LonerPinTheWinConerMultiView extends PIXI.Container {
    private _cornerMultipliersArray: LonerPinTheWinCornerMulti[] = [];

    constructor() {
        super();
        this.name = "LonerPinTheWinConerMultiView";
        this.init();
    }

    public showMultipliers(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        this._cornerMultipliersArray.forEach((individualMulti) => {
            tl.add(individualMulti.show(duration), 0);
        });
        return tl;
    }

    public hideMultipliers(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        this._cornerMultipliersArray.forEach((individualMulti) => {
            tl.add([individualMulti.hide(duration), () => {
                individualMulti.stopMaxWinSymbolBlink();
            }], 0);
        });
        return tl;
    }

    public stopMaxWinSymbolBlink(): void {
        this._cornerMultipliersArray.forEach((individualMulti) => {
            individualMulti.stopMaxWinSymbolBlink();
        });
    }

    public setAllMultiValue(setNextCornerValue: boolean = false): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        this._cornerMultipliersArray.forEach((individualMlti, idx) => {
            if (setNextCornerValue) {
                if (Loner.model.pinTheWinFeatureObj.nextCornerValues) {
                    individualMlti.setMulti(Loner.model.pinTheWinFeatureObj.nextCornerValues[idx]);
                }
            } else {
                if (Loner.model.pinTheWinFeatureObj.cornerValue) {
                    individualMlti.setMulti(Loner.model.pinTheWinFeatureObj.cornerValue[idx]);
                }
            }
        })
        return tl;
    }

    private init(): void {
        for (let idx = 0; idx < 4; idx++) {
            const multi: LonerPinTheWinCornerMulti = new LonerPinTheWinCornerMulti(idx);
            this.addChild(multi)
            this._cornerMultipliersArray.push(multi);
        }
    }
}